import React from 'react';

const Home = () => {

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };


  return (
    <section id="home" className="section">
      {/* Background is now in App.js */}
      
      <div className="home-content fade-in">
        <div className="text-reveal">
          <h1>
            NAMAL
            <br />
            CHAMODYA<span>.</span>
          </h1>
        </div>
        <div className="subtitle">
          <p>CREATIVE DEVELOPER & DESIGNER</p>
        </div>
        <div className="home-description">
          <p>Crafting immersive digital experiences through code and design.</p>
        </div>
        <div className="cta-buttons">
          <button 
            onClick={() => scrollToSection('projects')} 
            className="btn primary-btn"
          >
            View Projects
          </button>          

          <button 
            onClick={() => scrollToSection('contact')} 
            className="btn secondary-btn"
          >
            Get In Touch
          </button>          
        </div>
      </div>
      <div className="scroll-indicator">
        <p>SCROLL DOWN</p>
        <div className="scroll-arrow">
          <i className="fas fa-chevron-down"></i>
        </div>
      </div>
    </section>
  );
};

export default Home;